import { useState } from 'react';
import { NotificationRule } from '@/features/notification-rules/schemas/notification-rules.schema.ts';
import {
  Credenza,
  CredenzaBody,
  CredenzaContent,
  CredenzaDescription,
  CredenzaHeader,
  CredenzaTitle,
  CredenzaTrigger,
} from '@/components/ui/credenza.tsx';
import { NotificationRuleEditForm } from '@/features/notification-rules/components/edit-notification-rule/notification-rule-edit-form.tsx';

export function NotificationRulesTableRowActionEditDialog({
  notificationRule,
}: {
  notificationRule: NotificationRule;
}) {
  const [isDialogOpen, setIsDialogOpen] = useState(false);

  const onClose = () => setIsDialogOpen(false);

  return (
    <Credenza open={isDialogOpen} onOpenChange={setIsDialogOpen}>
      <CredenzaTrigger asChild>
        <button className="focus:bg-accent focus:text-accent-foreground relative flex w-full cursor-default items-center rounded-sm px-2 py-1.5 text-sm outline-hidden transition-colors select-none hover:bg-gray-100 data-disabled:pointer-events-none data-disabled:opacity-50">
          <span>Edit</span>
        </button>
      </CredenzaTrigger>
      <CredenzaContent>
        <CredenzaHeader>
          <CredenzaTitle>Edit {notificationRule.notificationTitle}</CredenzaTitle>
          <CredenzaDescription className="hidden">
            Update the configuration for notification rule. Changes will be applied upon
            saving.
          </CredenzaDescription>
        </CredenzaHeader>
        <CredenzaBody className="pb-4">
          <NotificationRuleEditForm notificationRule={notificationRule} onClose={onClose} />
        </CredenzaBody>
      </CredenzaContent>
    </Credenza>
  );
}

export default NotificationRulesTableRowActionEditDialog;
